<template lang="pug">
  div
    h3 {{$t('groupPages.modules.audios.title')}}
    audio
    .table-responsive
      table.table.table-hover.table-striped.audios
        tbody(v-sortable="{onUpdate: onListReorder, handle: '.drag-handle'}")
          tr.clickable(v-for='audio in items', @click="playItem(audio)")
            td
              i.fa.fa-play(v-if="!player.playing || currentItem != audio")
              i.fa.fa-pause(v-else)
            td {{audio.description}}
            td {{audio.size | hrS}}
            td 
              .duration
                span(v-if="player.showDuration && player.playing && currentItem == audio") {{player.currentSecond | hrT}} / {{player.duration | hrT}}
            td(v-if="openEditor")
              //- i.text-muted.fa.fa-arrows.drag-handle
              | &nbsp;&nbsp;&nbsp;
              i.text-danger.fa.fa-trash(@click="remove(audio, $event)")
    div(v-if="openEditor", @click="askUpload", role='button')
      .alert.alert-info.text-center
        i.fa.fa-upload.fa-2x
        br
        |  {{$t('groupPages.modules.audios.import')}}
</template>
<script type="text/javascript">
import {audiojs} from 'vshushkov-audiojs'
import {hrS, hrT} from '@/components/shared/vue.globals'

import _ from 'lodash'
import api from '@/utils/api'

export default {
  props: ['vueData', 'module', 'openEditor'],
  data () {
    return {
      audio: null,
      player: {
        playing: false,
        duration: 0,
        currentSecond: 0,
        showDuration: true
      },
      currentItem: undefined
    }
  },
  filters: {
    hrS,
    hrT
  },
  mounted () {
    const that = this
    this.audio = audiojs.create(document.getElementsByTagName('audio')[0], {
      css: '.audiojs{display: none}',
      // trackEnded: ->
      //  next = $('ol li.playing').next();
      //  if (!next.length) next = $('ol li').first();
      //  next.addClass('playing').siblings().removeClass('playing');
      //  audio.load($('a', next).attr('data-src'));
      //  audio.play();
      playPause () {
        that.player.playing = this.playing
      },
      play () {
        that.player.playing = true
      },
      pause () {
        that.player.playing = false
      },
      updatePlayhead (percent) {
        if (this.duration === Infinity) {
          that.player.showDuration = false
          return
        }
        that.player.duration = this.duration
        that.player.currentSecond = Math.floor(this.duration * percent)
      }
    }
    )
  },
  computed: {
    items () {
      let items = []
      for (let audio of this.module.items) {
        items.push({
          id: audio.id,
          src: audio.downloadLink + '?size=3',
          description: audio.name,
          size: audio.size
        })
      }
      return items
    }
  },
  methods: {
    playItem (item) {
      if (this.currentItem === item) {
        return this.audio.playPause()
      }
      this.player.showDuration = true
      this.player.duration = 1
      this.player.currentSecond = 0
      this.currentItem = item
      this.audio.load(item.src)
      this.audio.play()
    },
    askUpload () {
      this.$emit('askUpload')
    },
    stopItem (item) {
      if (this.currentItem === item) {
        return this.audio.playPause()
      }
    },
    onListReorder (event) {
      // this.module.items.splice(event.newIndex, 0, this.module.items.splice(event.oldIndex, 1)[0])
      // const oldItems = this.module.items
      // this.module.items = []
      // this.$nextTick(() => {
      //   this.module.items = oldItems
      //   console.log('new list', this.module.items)
      // })
    },
    remove (item, $event) {
      $event.stopPropagation()
      this.stopItem(item)
      let index = _.findIndex(this.module.items, t => t.id === item.id)
      this.module.items.splice(index, 1)
      api.put('/node', {
        id: item.id,
        kind: 'file',
        public: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageAudios.vue?369f0572